module.exports = __webpack_public_path__ + "/images/cover-box-sorteo-@2x.78ed45e.jpg";